import { useAxios } from "./apiHelper";
export const useApiCategoryStock = () => {
  const httpRequest = useAxios();
  return {
    CreateCategoryStock: (jsonData) => {
      const formData = new FormData();
      formData.append("nameCata", jsonData.nameCata);

      return httpRequest.post("/cata/insert-cata", formData);
    },
    DeleteGroupCategoryStock: (jsonData) => {
      const formData = new FormData();
      formData.append("lstid", jsonData.lstid);

      return httpRequest.post("/cata/del-cata", formData);
    },
    AddNewSymbolIntoCategory: (jsonData) => {
      return httpRequest.post("/CategoryStock/AddNewSymbol", jsonData);
    },
    EditGroupStock: (jsonData) => {
      const formData = new FormData();
      formData.append("lstid", jsonData.lstid);
      jsonData.newNameCata && jsonData.newNameCata !== undefined ? formData.append("newNameCata", jsonData.newNameCata) : undefined;
      jsonData.code && jsonData.code !== undefined ? formData.append("code", jsonData.code) : undefined;
      jsonData.type && jsonData.type !== undefined ? formData.append("type", jsonData.type) : undefined;

      return httpRequest.post("/cata/edit-cata", formData);
    },
    RemoveSymbolInCategoryStock: (jsonData) => {
      const formData = new FormData();
      formData.append("lstid", jsonData.lstid);
      jsonData.newNameCata && jsonData.newNameCata !== undefined ? formData.append("newNameCata", jsonData.newNameCata) : undefined;
      jsonData.code && jsonData.code !== undefined ? formData.append("code", jsonData.code) : undefined;
      jsonData.type && jsonData.type !== undefined ? formData.append("type", jsonData.type) : undefined;

      return httpRequest.post("/CategoryStock/RemoveSymbol", formData);
    },
    CategoryStock: () => {
      return httpRequest.get("/cata/load-cata");
    },
    GetHistoryStock: (jsonData) => {
      const formData = new FormData();
      formData.append("symbol", jsonData.symbol);

      return httpRequest.post("/get-data-history-stock", formData);
    },
    GetIpServer: () => {
      return httpRequest.get("/ip-server");
    },
  };
};
